import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
	DepositPromotionMutationKeys,
	DepositPromotionQueryKeys,
} from '../../../keys'
import { applyDepositPromotionPreset } from '../../services'
import type {
	ApplyDepositPromotionPresetRequest,
	ApplyDepositPromotionPresetResponse,
} from '../../../type'

interface MutationVariables {
	presetId: string
	payload: ApplyDepositPromotionPresetRequest
}

export default function useMutationApplyDepositPromotionPreset() {
	const queryClient = useQueryClient()

	return useMutation<
		ApplyDepositPromotionPresetResponse,
		unknown,
		MutationVariables
	>({
		mutationKey: [DepositPromotionMutationKeys.ApplyDepositPromotionPreset],
		mutationFn: ({ presetId, payload }) =>
			applyDepositPromotionPreset(presetId, payload),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [DepositPromotionQueryKeys.GetDepositPromotionList],
			})
		},
	})
}
